<div class="readonly-field">
  <div class="readonly-field-text">
    <span class="readonly-field-label">{{ label }}</span>
    <span class="readonly-field-value">{{ displayValue }}</span>
  </div>
  @if (locked) {
    <mat-icon class="mat-icon-readonly-field-lock" aria-hidden="true">lock</mat-icon>
  }
</div>
